module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-1@3x.jpg?93abf7b7";